{
  "title": "WebSocket Debug",
  "connectionTester": {
    "title": "Connection Tester",
    "connect": "Connect",
    "disconnect": "Disconnect",
    "clearLog": "Clear Log",
    "send": "Send",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "connecting": "Connecting...",
    "error": "Error",
    "actionHint": "Select an action or choose \"Raw JSON\" for custom messages",
    "customJson": "Raw JSON...",
    "payloadPlaceholder": "optional payload JSON",
    "noPayload": "no payload needed"
  },
  "originRotation": {
    "title": "Origin Rotation",
    "parameter": "Parameter",
    "lastRotated": "Last Rotated",
    "nextScheduled": "Next Scheduled",
    "apiDistribution": "API Distribution",
    "wsDistribution": "WS Distribution",
    "rotateNow": "Rotate Now",
    "idle": "Idle — awaiting trigger",
    "rotating": "Rotating...",
    "success": "Rotation completed",
    "confirmTitle": "Confirm Rotation",
    "confirmMessage": "Are you sure you want to rotate the origin-verify secret? This will update both CloudFront distributions.",
    "cancel": "Cancel",
    "confirm": "Rotate"
  },
  "activeConnections": {
    "title": "Active Connections",
    "autoRefresh": "Auto-refresh: 10s",
    "refresh": "Refresh",
    "loadMore": "Load More",
    "noConnections": "No active connections",
    "userId": "User ID",
    "connectionId": "Connection ID",
    "connectedAt": "Connected At",
    "ttl": "TTL",
    "deviceInfo": "Device Info"
  },
  "payloadForm": {
    "status": "Status",
    "currentGameId": "Game ID (optional)",
    "currentMatchId": "Match ID (optional)",
    "userIds": "User IDs",
    "userIdsHint": "Comma-separated UUIDs",
    "message": "Message"
  }
}
